var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Button',_vm._g(_vm._b({staticClass:"filter-btn",attrs:{"variant":"outline","size":"small"}},'Button',{ ..._vm.$props, ..._vm.$attrs },false),_vm.$listeners),[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }